export default __webpack_public_path__ + "static/media/icons-18.555b8d50.svg";